import { FC } from 'react';

export interface IToolDataSubcategory {
  id: string;
  label: string;
  href: string;
  openInNewTab?: boolean;
}

export interface IToolIcon {
  src: FC;
  width?: number;
  height?: number;
  background?: string;
  fill?: string;
  noColor?: boolean;
}

export interface IBottomLink {
  text: string;
  href: string;
}

export interface IToolData {
  id: string;
  longName?: string;
  name: string;
  description?: string;
  href?: string;
  buttonHref?: string;
  widgetUrl?: string;
  icon?: IToolIcon;
  categories?: string[];
  isNew?: boolean;
  showLabelOnNavBar?: boolean;
  openInNewTab?: boolean;
  subCategories?: IToolDataSubcategory[];
  bottomLinks?: IBottomLink[];
  iconRound?: boolean;
}

export enum ToolCategory {
  All = 'All',
  AiWriter = 'AI Writer',
  Design = 'Design',
  Video = 'Video',
  Text = 'Text',
  Color = 'Color',
  Convert = 'Convert',
  PDF = 'PDF',
  Image = 'Image',
}

export interface IToolCategory {
  value: ToolCategory;
  name?: string;
  backgroundColor?: string;
  icon?: {
    Component: FC;
    width?: number;
    height?: number;
    src: FC;
    background: string;
    fill: string;
  };
  href?: string;
  toolsCount?: number;
}
